import { useCallback } from "react"
import { useTrackEvent } from "../../providers/TrackEventProvider"
import { FlowActions } from "../../stores/flowStore"
import type { SwapFlowInitialCurrency } from "../flow-state"

type SwapProps = {
  buttonColor?: string
  onBack?: () => void
  initialFromCurrency?: SwapFlowInitialCurrency
  initialToCurrency?: SwapFlowInitialCurrency
}

export const useSwapFlow = () => {
  const trackSwapFlowStarted = useTrackSwapFlowStarted()

  return useCallback(
    ({
      buttonColor,
      onBack,
      initialFromCurrency,
      initialToCurrency,
    }: SwapProps = {}) => {
      FlowActions.startFlow({
        type: "swap",
        buttonColor,
        onBack,
        initialFromCurrency,
        initialToCurrency,
      })
      trackSwapFlowStarted({
        initialFromCurrency,
        initialToCurrency,
      })
    },
    [trackSwapFlowStarted],
  )
}

type TrackSwapFlowStartedProps = {
  initialFromCurrency: SwapFlowInitialCurrency | undefined
  initialToCurrency: SwapFlowInitialCurrency | undefined
}

const useTrackSwapFlowStarted = () => {
  const trackEvent = useTrackEvent()

  const trackSwapFlowStarted = useCallback(
    ({ initialFromCurrency, initialToCurrency }: TrackSwapFlowStartedProps) => {
      trackEvent("Swap Flow Started", {
        fromCurrency: initialFromCurrency
          ? {
              symbol: initialFromCurrency.symbol,
              contractAddress: initialFromCurrency.contractAddress,
              chain: initialFromCurrency.chainIdentifier,
            }
          : undefined,
        toCurrency: initialToCurrency
          ? {
              symbol: initialToCurrency.symbol,
              contractAddress: initialToCurrency.contractAddress,
              chain: initialToCurrency.chainIdentifier,
            }
          : undefined,
      })
    },
    [trackEvent],
  )

  return trackSwapFlowStarted
}
